<div class="case-request-wrapper">
    <h1 class="bo-title-text d-none" [innerHtml]="referenceDataLabels.CaseSummaryCaseActivity | localizeLabel"></h1>
    <ng-container *ngIf="caseRequests$ | async as caseRequests">
        <div *ngIf="caseRequests.length > 0" class="bo-label-text vo-heading-regular-18 mb-15"
            [innerHtml]="referenceDataLabels.CaseActivity | localizeLabel"></div>
        <div class="mb-30" *ngFor="let caseRequest of caseRequests">
            <boi-case-request-status-history class="activity-container" [caseRequest]="caseRequest">
            </boi-case-request-status-history>

            <div class="artefact bo-label-text vo-body-regular-14">
                <span class="vo-body-bold-14" [innerHtml]="(caseRequest.RequestTypeCode === referenceDataOptionLists.SwitchRequestTypeEsis ?
                referenceDataLabels.RequestIllustration :
                referenceDataLabels.RequestSwitch) | localizeLabel"></span>
                <span class="bo-info-text"
                    [innerHtml]="' ' + (caseRequest.CreatedDate | date: 'dd/MM/yyyy HH:mm:ss') + ' '"></span>

                <span class="bo-info-text" [innerHtml]="' ' + (referenceDataLabels.By | localizeLabel) + ' '"></span>

                <a class="link" *ngIf="caseRequest.AgentIDAsHash"
                    (click)="goToAgentDetails.emit(caseRequest.AgentIDAsHash)">{{caseRequest.AgentFullName}}
                    ({{caseRequest.AgentCompany}})</a>
                <a class="link" *ngIf="caseRequest.DirectCustomerIDAsHash"
                    (click)="goToCustomersTab.emit()">{{caseRequest.DirectCustomerFullName}}</a>

                <div>
                    <span class="bo-info-text">{{caseRequest.ProductDescription}} ({{caseRequest.ProductCode}}) |
                    </span>
                    <span class="bo-info-text">{{caseRequest.AccountLTV}}% {{referenceDataLabels.LTV | localizeLabel}} |
                    </span>
                    <span class="bo-info-text">{{caseRequest.SwitchedSubaccountsInfo}} | </span>
                    <span boiCategorizeCaseStatus [caseStatus]="caseRequest.StatusCode"
                        [innerHtml]="caseRequest.StatusCode | localizeOption: referenceDataOptionLists.SwitchCaseStatus"></span>
                </div>
            </div>
        </div>
    </ng-container>
</div>